import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider, App as AntApp } from "antd";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <React.StrictMode>
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: "#00AF66",
                    borderRadius: 8,
                    fontFamily: "inherit",
                },
            }}
        >
            <AntApp>
                <App />
            </AntApp>
        </ConfigProvider>
    </React.StrictMode>
);

reportWebVitals();